export default (props, e) => {
	e.preventDefault();
	const dropDowns = document.querySelectorAll('.header .dropdown');
	const fulltextQuery = document.getElementById('query');
	if (e.target.parentElement.classList.contains('opened')) {
		e.target.parentElement.classList.remove('opened');
		if(e.target.nextElementSibling.hasAttribute('aria-hidden')) {
			e.target.nextElementSibling.setAttribute('aria-hidden', 'true');
		}
		document.body.classList.remove('megamenu-opened');
	} else {
		dropDowns.forEach((dropDown) => {
			dropDown.classList.remove('opened');
		});
		e.target.parentElement.classList.add('opened');
		if(e.target.nextElementSibling.hasAttribute('aria-hidden')) {
			e.target.nextElementSibling.setAttribute('aria-hidden', 'false');
		}
		fulltextQuery.focus();
		document.body.classList.add('megamenu-opened');
	}

	document.addEventListener('keydown', _closeFulltextDropdownOnEscape);

	function _closeFulltextDropdownOnEscape(e) {
		if (document.getElementById('js_fulltextDropdown').classList.contains('opened') && e.key === "Escape") {
			document.querySelector('.fulltext .btn-close').click();
		}
	}
};




// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/webActions/headerNavDropdownHandler.js